import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters';
import colors from '../../../vars/colors';

export const TwoUpImage = styled.div`
    position: relative;
    width: 100%;    
    ${props => (props.imageIndex % 2 === 1) && css`
        margin-top: 140px;
        `
    }
    @media (max-width: ${breakpoints['bp-desktop']}) {
        ${props => (props.imageIndex % 2 === 1) && css`
            margin-top: 100px;
            `
        }
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        ${props => (props.imageIndex % 2 === 1) && css`
            margin-top: 80px;
            `
        }
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        margin-top: 20px;
        margin-bottom: 40px;
    }
    .twoUpBackground {
        position: absolute;        
        z-index: -1;
        width: 80%;
        overflow: hidden;
        &.left {
            top: 55%;
            left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
            @media (max-width: ${breakpoints['bp-desktop']}) {
                left: calc(${gutters['container-gutters-desktop']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                left: calc(${gutters['container-gutters-tablet']} * -0.8);
                bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                top: 25%;
                left: calc(${gutters['container-gutters-mobile']} * -0.8);
                bottom: calc(${gutters['container-gutters-mobile']} * -0.7);
            }            
        }
        &.right {
            bottom: 55%;
            right: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            top: calc(${gutters['container-gutters-desktop-l']} * -0.7);
            @media (max-width: ${breakpoints['bp-desktop']}) {
                right: calc(${gutters['container-gutters-desktop']} * -0.8);
                top: calc(${gutters['container-gutters-desktop']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                right: calc(${gutters['container-gutters-tablet']} * -0.8);
                top: calc(${gutters['container-gutters-tablet']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                right: calc(${gutters['container-gutters-mobile']} * -0.8);
                top: calc(${gutters['container-gutters-mobile']} * -0.7);
            }
        }
        .colorBlock {
            position: absolute;
            top: -75px;
            left: -75px;
            right: -75px;
            bottom: -75px;
            background: repeating-linear-gradient(-45deg, ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']}, ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
            animation-name: barbersPole;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-duration: 1200ms;
            animation-play-state: running;
            @keyframes barbersPole {
                0% {transform: translate3d(0, 0, 0)}
                100% {transform: translate3d(0, 72px, 0)}
            }
        }        
    }
    &:hover {
        .colorBlock {
            animation-play-state: paused;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/modules/TwoUp/styled-components.js